import { timeAndLoadTypes } from "@/api/femsAPI";
import { CalendarDate } from "@/components/Calendar";
import { useQuery } from "@tanstack/react-query";
import { ProcessQueryEnabeld } from "./useProcessedQuery";

export const useDailyHourQuery = (
  {
    dailyTrioEnabled,
    dailyTrioLoadTypeEnabled,
    hourlyEnabled,
    hourlyLoadTypeEnabled,
    dailySingleLoadTypeEnabled,
    dailyTimeLoadTypeEnabled,
    dailyEnabled,
    fifteenMinuteEnabled,
    dailyPairEnabled,
    dailySingleEnabled,
  }: ProcessQueryEnabeld,
  selectedDate?: CalendarDate,
  equipment?: string | null,
) => {
  const today = (selectedDate && selectedDate[0]) ?? new Date();
  // const year = today.getUTCFullYear();
  // const month = today.getUTCMonth() + 1; // getUTCMonth()는 0부터 시작하므로 1을 더합니다.
  // const day = today.getUTCDate();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const start = `${year}-${String(month).padStart(2, "0")}-${String(day - 1).padStart(
    2,
    "0",
  )}T15:00:00.000Z`;
  const end = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
    2,
    "0",
  )}T15:00:00.000Z`;

  // 기간 + 3개의 data
  const { data: dailyTrio, isLoading: dailyTrioLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "DAILY_TRIO",
      date: `${year}-${month}-${day}`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: dailyTrioEnabled,
  });

  // 기간 + 2개의 data
  const { data: dailyPair, isLoading: dailyPairLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "DAILY_PAIR",
      date: `${year}-${month}-${day}`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: dailyPairEnabled,
  });

  // 기간(시간대) + 1개의 data
  const { data: dailySingleLoadType, isLoading: dailySingleLoadTypeLoading } = useQuery({
    ...timeAndLoadTypes.getPeriodLoadType({
      start: start,
      end: end,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: dailySingleLoadTypeEnabled,
  });

  // 기간/부하별 + 3개의 data
  const { data: dailyTrioLoadType, isLoading: dailyTrioLoadTypeLoading } = useQuery({
    ...timeAndLoadTypes.getPeriodLoadType({
      start: start,
      end: end,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: dailyTrioLoadTypeEnabled,
  });

  // 시간별 data
  const { data: hourly, isLoading: hourlyLoading } = useQuery({
    ...timeAndLoadTypes.getTimeHourly({
      year: year,
      month: month,
      day: day,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: hourlyEnabled,
  });

  // 시간 + 부하별 data
  const { data: hourlyLoadType, isLoading: hourlyLoadTypeLoading } = useQuery({
    ...timeAndLoadTypes.getTimeHourlyLoadType({
      year: year,
      month: month,
      day: day,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: hourlyLoadTypeEnabled,
  });

  // 일별 + 부하별 data
  const { data: dailyTimeLoadType, isLoading: dailyTimeLoadTypeLoading } = useQuery({
    ...timeAndLoadTypes.getTimeDailyLoadType({
      year: year,
      month: month,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: dailyTimeLoadTypeEnabled,
  });

  // 일별 data
  const { data: daily, isLoading: dailyLoading } = useQuery({
    ...timeAndLoadTypes.getTimeDaily({
      year: year,
      month: month,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: dailyEnabled,
  });

  // 15분별 data
  const { data: fifteenMinutes, isLoading: fifteenMinutesLoading } = useQuery({
    ...timeAndLoadTypes.getQuarterHourly({
      year: year,
      month: month,
      day: day,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: fifteenMinuteEnabled,
  });

  const { data: dailySingle, isLoading: dailySingleLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "DAILY_SINGLE",
      date: `${year}-${month}-${day}`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: dailySingleEnabled,
  });

  const { data: currentLoadType } = useQuery({
    ...timeAndLoadTypes.getCurrentLoadType({}),
  });

  return {
    dailyTrio,
    dailySingleLoadType,
    hourly,
    dailyTrioLoadType,
    hourlyLoadType,
    dailyTimeLoadType,
    daily,
    fifteenMinutes,
    dailyPair,
    dailySingle,
    currentLoadType,

    dailyTrioLoading,
    dailySingleLoadTypeLoading,
    hourlyLoading,
    dailyTrioLoadTypeLoading,
    hourlyLoadTypeLoading,
    dailyTimeLoadTypeLoading,
    dailyLoading,
    fifteenMinutesLoading,
    dailyPairLoading,
    dailySingleLoading,
  };
};
